// Formata a data para dd/mm/yyyy
export function formatDate(dateString) {
  const date = new Date(dateString);
  if (isNaN(date)) return "";
  const day = date.getDate().toString().padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
}

// Converte para o formato yyyy-mm-dd (para usar em <input type="date" />)
export function convertToInputDate(dateString) {
  const date = new Date(dateString);
  if (isNaN(date)) return "";
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const day = date.getDate().toString().padStart(2, '0');
  return `${year}-${month}-${day}`;
}

// Retorna quantos dias correspondem a um filtro de data
export function getDiasFromFiltro(filtro) {
  // Se filtro for null ou "Datas Específicas", retornar null
  if (filtro === null || filtro === "Datas Específicas") return null;

  if (filtro === "Mês atual") return new Date().getDate();

  const mapa = {
    "Últimos 7 dias": 7,
    "Últimos 30 dias": 30,
    "Últimos 3 meses": 90,
    "Últimos 6 meses": 180,
    "Últimos 12 meses": 365,
  };

  return mapa[filtro] || 0;
}